import generatePayload from 'promptpay-qr';
import QRCode from 'qrcode';

/**
 * Generate PromptPay QR Code for payment using official library
 */

/**
 * Generate PromptPay QR Code data URL
 * @param identifier - PromptPay phone number (10 digits) or ID card (13 digits)
 * @param amount - Payment amount in baht
 * @returns Data URL for QR code image
 */
export const generatePromptPayQR = async (
  identifier: string,
  amount: number
): Promise<string> => {
  try {
    // Remove any non-digit characters
    const cleanIdentifier = identifier.replace(/\D/g, '');
    
    // Validate identifier
    if (cleanIdentifier.length !== 10 && cleanIdentifier.length !== 13) {
      throw new Error('เบอร์โทรศัพท์ต้องเป็น 10 หลัก หรือเลขบัตรประชาชน 13 หลัก');
    }

    // Generate PromptPay payload using official library
    const payload = generatePayload(cleanIdentifier, { amount });
    
    // Generate QR code as data URL
    const qrCodeDataUrl = await QRCode.toDataURL(payload, {
      width: 512,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
    
    return qrCodeDataUrl;
  } catch (error) {
    console.error('[PromptPay QR] Error generating QR:', error);
    throw error;
  }
};

/**
 * Validate PromptPay phone number
 */
export const validatePromptPayPhone = (phoneNumber: string): boolean => {
  const cleanPhone = phoneNumber.replace(/\D/g, '');
  return cleanPhone.length === 10 && /^0[0-9]{9}$/.test(cleanPhone);
};
